import message from '../message';
export default function(
    img: { width: number; height: number; size: number },
    sizeLimit: number,
    ratioLimit: number[],
    widthLimit: number[],
    heightLimit: number[]
) {
    if (img.size / 1024 > sizeLimit) {
        message.error('图片大小超过限制，不能超过：' + sizeLimit + 'Kb');
        return false;
    }
    if (img.width / img.height < ratioLimit[0] || img.width / img.height > ratioLimit[1]) {
        message.error('图片宽高比超过限制');
        return false;
    }
    if (img.width < widthLimit[0]) {
        message.error('图片宽度小于最低限制：' + widthLimit[0] + 'px');
        return false;
    }
    if (img.width > widthLimit[1]) {
        message.error('图片宽度大于最高限制：' + widthLimit[1] + 'px');
        return false;
    }
    if (img.height < heightLimit[0]) {
        message.error('图片高度小于最低限制：' + heightLimit[0] + 'px');
        return false;
    }
    if (img.height > heightLimit[1]) {
        message.error('图片高度大于最高限制：' + heightLimit[1] + 'px');
        return false;
    }
    return true;
}
